/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { isNotEmpty, handleFormikCheckboxChange } from "../../utils";
import InputAlert from "./InputAlert";
import { AlertType } from "../../constants";

type Props = {
  id?: string;
  input?: $TSFixMe;
  label?: string;
  labelNode?: React.ReactNode;
  meta?: $TSFixMe;
  disabled?: boolean;
  handleChange?: $TSFixMeFunction;
  handleBlur?: $TSFixMeFunction;
  name?: string;
  status?: string;
  isSubmitting?: boolean;
  touched?: $TSFixMe;
  errors?: $TSFixMe;
  values?: $TSFixMe;
  additionalClassName?: string;
};

function Checkbox(props: Props) {
  const { input, label, labelNode, meta, disabled, id, additionalClassName } =
    props;

  // REDUX FORM
  if (input) {
    const { touched, error } = meta;
    const defaultClassName =
      touched && isNotEmpty(error) ? "form-group has-error" : "form-group";
    const className = additionalClassName
      ? `${defaultClassName} ${additionalClassName}`
      : defaultClassName;
    const errorMessage = touched && isNotEmpty(error) ? error : null;
    return (
      <div className={className}>
        <input {...input} id={id} type="checkbox" disabled={disabled} />
        <label htmlFor={id}>
          {label}
          {labelNode}
        </label>
        <InputAlert message={errorMessage} type={AlertType.ERROR} />
      </div>
    );
  }

  // FORMIK FORM
  const { name, isSubmitting, values, errors, status, touched } = props;
  // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
  const dirty = status === "submitted" || touched[name];
  const defaultClassName =
    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    dirty && isNotEmpty(errors[name]) ? "form-group has-error" : "form-group";
  const className = additionalClassName
    ? `${defaultClassName} ${additionalClassName}`
    : defaultClassName;
  // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
  const errorMessage = dirty && isNotEmpty(errors[name]) ? errors[name] : null;
  // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
  const value = values[name] === true ? true : false; // eslint-disable-line no-unneeded-ternary
  return (
    <div
      data-testid={`checkbox-${name}`}
      className={className}
      // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
      onClick={() => handleFormikCheckboxChange(props)}
    >
      <input
        id={id}
        name={name}
        checked={value}
        // will never be called but makes react happy
        onChange={
          // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
          /* istanbul ignore next */ () => handleFormikCheckboxChange(props)
        }
        type="checkbox"
        disabled={isSubmitting}
      />
      <label>
        {label}
        {labelNode}
      </label>
      <InputAlert message={errorMessage} type={AlertType.ERROR} />
    </div>
  );
}

export default Checkbox;
